import classNames from 'classnames';
import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import * as styles from './SelectOption.module.scss';
import SelectOptionContent from './SelectOptionContent';

export type SelectOptionType<T> = React.ComponentProps<
  typeof SelectOptionContent
> & {
  value: T;
  hidden?: boolean;
  isDisabled?: boolean;
};

const SelectOption = <T, IsMulti extends boolean = false>(
  props: OptionProps<SelectOptionType<T>, IsMulti>,
) => {
  return (
    <div className={classNames({ [styles.hide]: props.data.hidden })}>
      <components.Option {...props}>
        <SelectOptionContent {...props.data} />
      </components.Option>
    </div>
  );
};

export default SelectOption;
